import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var DigitalTranslationsActions = function DigitalTranslationsActions(_ref) {
  var digitalTranslation = _ref.digitalTranslation,
    downloading = _ref.downloading,
    getDownloadUrl = _ref.getDownloadUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, digitalTranslation.failed ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger mb-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-failure"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, digitalTranslation.completed ? /*#__PURE__*/React.createElement(React.Fragment, null, downloading(digitalTranslation) ? /*#__PURE__*/React.createElement("span", {
    className: "text-nowrap ms-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-2",
    spin: true,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Downloading..."
  })) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return getDownloadUrl(digitalTranslation.identity, digitalTranslation.file.name);
    },
    className: "text-nowrap ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-download"
  }))) : null)), /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-upload-status",
    params: {
      date: digitalTranslation.createdAt
    }
  }), digitalTranslation.processing ? /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0\xB7\xA0", /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-in-progress"
  })) : null);
};
export default DigitalTranslationsActions;